import { ArrowUpRight, AudioLines, Wind, Flower2, ThermometerSun, Dna, Star, Music, ChefHat, Headphones, Brain, Palette, Brush, Music4 } from "lucide-react";
import { Reveal } from "./Reveal";

const ACTIVATIONS = [
  ["Bain sonore", AudioLines],
  ["Breathwork", Wind],
  ["Yoga", Flower2],
  ["Contrast therapy", ThermometerSun],
  ["Bio Hacking", Dna],
  ["Astro", Star],
  ["Ecstatic Dance", Music],
  ["Cooking Class", ChefHat],
  ["Sieste Electronique", Headphones],
  ["Méditation guidée", Brain],
  ["Art therapy", Palette],
  ["Body painting", Brush],
  ["Danse", Music4],
];

export default function Agence() {
  return (
    <section
      id="agence"
      data-testid="section-agence"
      className="relative py-24 md:py-32 overflow-hidden"
      style={{ background: "linear-gradient(180deg, rgba(214,71,142,0.10), rgba(255,179,71,0.10))" }}
    >
      <div className="orb w-[420px] h-[420px] bg-[#FF8E53] blur-[130px] opacity-30 top-0 right-[-8%]" aria-hidden="true" />

      <div className="wrap relative">
        <Reveal>
          <p className="font-mono2 font-bold text-sm md:text-base tracking-[0.18em] uppercase text-[#E8431F] mb-6">
            Pour les agences
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl leading-[1.08] tracking-[-0.02em] max-w-[24ch]">
            Vous êtes une agence événementiel et voulez proposer des activations wellness à vos clients ?
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="font-serifit italic text-2xl md:text-3xl mt-6 text-[#5F5258]">
            Faisons le ensemble !
          </p>
        </Reveal>
        <Reveal className="mt-10" delay={0.2}>
          <a
            href="mailto:alexia@ommymind.org?subject=Partenariat%20agence"
            data-testid="agence-cta"
            className="btn btn-ink"
          >
            Nous écrire
            <ArrowUpRight size={16} />
          </a>
        </Reveal>

        <Reveal className="mt-14 md:mt-16" delay={0.25}>
          <p className="font-mono2 font-bold text-sm tracking-[0.18em] uppercase text-[#33181F]/60 mb-6">
            Activations wellness possibles
          </p>
          <div className="flex flex-wrap gap-3">
            {ACTIVATIONS.map(([label, Icon], i) => (
              <span
                key={label}
                data-testid={`activation-${i + 1}`}
                className="tag-pill glass inline-flex items-center gap-2.5 cursor-default"
              >
                <Icon size={15} strokeWidth={1.8} className="text-[#E8431F]" />
                {label}
              </span>
            ))}
            <span className="tag-pill inline-flex items-center font-serifit italic text-[#5F5258] border-transparent">
              et bien plus…
            </span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
